export default "__VITE_ASSET__jDexhtLk__"